import { nullCheck } from "../utils/dataHelpers";

export default class LoadBoardSerializer {
  static serialize(data) {
    return data;
  }

  static deSerialize(data) {
    return {
      orderId: data.orderId,
      originSchedArriveEarly: data.originSchedArriveEarly,
      originSchedArriveLate: data.originSchedArriveLate,
      destinationSchedArriveEarly: data.destinationSchedArriveEarly,
      destinationSchedArriveLate: data.destinationSchedArriveLate,
      originCity: data.originCity,
      originState: data.originState,
      destinationCity: data.destinationCity,
      destinationState: data.destinationState,
      targetPay: data.overrideTargetPay,
      maxPay: data.overrideMaxtPay,
      tenderType: data.tenderType,
      orderTypeId: data.orderTypeId,
      mode: data.mode,
      customerId: data.customerId,
      customerName: data.customerName,
      operationsRep: data.operationsRep,
      accountMgr: data.accountMgr,
      weight: data.weight,
      miles: data.billDistance,
      billDistanceUm: data.billDistanceUm,
      customerTotalCharges: data.customerTotalCharges,
      offerCount: data.offerCount,
      lowestOffer: data.lowestOffer,
      brokerageStatus: data.brokerageStatus,
      commodity: data.commodity,
      minTemp: data.temperatureMin,
      maxTemp: data.temperatureMax,
      lastCallDateName: data.lastCallCityName,
      currentCityName: data.currentCityName,
      currentState: data.currentState,
      currentLocation: data.currentCityName && data.currentState ? `${data.currentCityName}, ${data.currentState}` : null,
      newEta: data.newEta,
      trackStatus: data.brTrackStatus,
      nextStop: data.nextStopCity && data.nextStopState ? `${data.nextStopCity}, ${data.nextStopState}` : null,
      distanceNextStop: parseInt(nullCheck(data, "0.0", "distanceToNextStop")),
      stops: data.extraStops,
      nextSchedCall: data.nextSchedCall,
      datId: nullCheck(data, null, "datId"),
      carrierPay: data.carrierPay,
      grossProfit: data.grossProfit,
      ...data
    };
  }
}